import { TableTemplate } from '@/features/baseTable'
import { CardTableSkeleton } from '@/features/baseTable/ui/CardTableSkeleton'
import { useWithdrawsTrader, TraderWithdrawFilterStatus } from '@/features/withdraws'
import { BaseCard, FilterButton, FilterButtonModel } from '@/shared/components'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { withdrawsAssinedColumns, withdrawsPaidColumns } from './model'
import { withdrawsAcceptedColumns } from '@/features/dashboardTrader/ui/TableCards/TraderTableCards/model/withdrawsAcceptedColumns'

const filterButtons: FilterButtonModel[] = [
  { name: 'Ожидают', label: 'waiting', index: 1 },
  { name: 'В работе', label: 'inProgress', index: 2 },
  { name: 'Завершенные', label: 'paid', index: 3 },
]

// Маппинг индекса фильтра на статус API
const statusMap: Record<number, TraderWithdrawFilterStatus> = {
  1: TraderWithdrawFilterStatus.Waiting,
  2: TraderWithdrawFilterStatus.InProgress,
  3: TraderWithdrawFilterStatus.Paid,
}

export const TraderWithdrawsCard = () => {
  const [selected, setSelected] = useState(1)

  const handleFilterClick = (button: FilterButtonModel) => {
    setSelected(button.index)
  }

  const { data, errors, loading } = useWithdrawsTrader({
    status: statusMap[selected],
    take: 10,
  })

  return (
    <BaseCard className="w-full" variant="secondary" radius="lg">
      <div className="flex justify-between items-center mb-4 md:mb-6">
        <h3>Исходящие заявки</h3>
        <Link to="/payout" className="text-primary dark:text-primary-dark text-sm">
          Показать все
        </Link>
      </div>
      <div className="flex gap-0.5 mb-5 p-0.5 overflow-x-auto scrollbar-hide">
        {filterButtons.map((b) => (
          <FilterButton
            key={b.index}
            name={b.name}
            onClick={() => handleFilterClick(b)}
            selected={b.index === selected}
            padding="sm"
          />
        ))}
      </div>
      {errors.withdrawsError ? (
        <p>Ошибка загрузки данных.</p>
      ) : loading.isWithdrawsLoading ? (
        <CardTableSkeleton />
      ) : !data.withdrawsData?.items || data.withdrawsData.items.length === 0 ? (
        <p>Данных нет.</p>
      ) : (
        <div className="pr-2 max-h-[240px] overflow-auto custom-scrollbar">
          {selected === 1 ? (
            <TableTemplate columns={withdrawsAssinedColumns} data={data.withdrawsData.items} />
          ) : selected === 2 ? (
            <TableTemplate columns={withdrawsAcceptedColumns} data={data.withdrawsData.items} />
          ) : selected === 3 ? (
            <TableTemplate columns={withdrawsPaidColumns} data={data.withdrawsData.items} />
          ) : null}
        </div>
      )}
    </BaseCard>
  )
}
